import { BillingClosePreBilling } from '../billing/billing-close-pre-billing';
import { MedicalOrderScannType } from '../medical-order-scann-type';
import { BillingClosePeriod } from '../billing/billing-close-period';

export class BillingScheduleTaskParameter {
    public BillingClosePreBillings: BillingClosePreBillingParameter[];
    public MedicalOrderScannTypes: MedicalOrderScannType[];
    public MedicalAppointmentProcedureIds: number[];
    public MedicalAppointmentIds: number[];
    public InvoiceNumber: string;
    public InvoicePoint: string;
    public InvoiceLabelType: string;
    public AgruparPorPlan: boolean;
    public AgruparPorPlanYContraste: boolean;
}

export interface BillingClosePreBillingParameter {
    SelectedBillingClosePeriod: BillingClosePeriod;
    MedicalAppointmentProcedureIds: number[];
}
